import favoriteService from 'common/util/favoriteService';

export default function () {
	let updateQuantity = (elem, count) => {
		$(elem).html(count);

		if (count === 0) {
			$(elem).addClass('js-empty');
		} else {
			$(elem).removeClass('js-empty');
		}
	};

	let handleChange = () => {
		let count = favoriteService.count();
		updateQuantity('.e-favorites__quantity', count);
		updateQuantity('.favorites__quantity', count);
	};

	favoriteService.addListenerAdd(handleChange);
	favoriteService.addListenerRemove(handleChange);
}
